import React, { FC, ReactElement } from 'react';

import classNames from 'classnames';

import Mobile from '@/components/Device/Mobile';
import PC from '@/components/Device/PC';

interface Props {
  items: { key: string; value: ReactElement }[];
  itemStyle?: React.CSSProperties;
  className?: string;
  itemClassName?: string;
  columns?: number;
}

const List: FC<Props> = ({ items, itemStyle, className = '', itemClassName = '' }) => {
  return (
    <>
      <PC>
        <div
          className={classNames('grid gap-[20px]', className)}
          style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(${itemStyle?.width}px, 1fr))`,
          }}
        >
          {items?.map(({ key, value }) => (
            <div key={key} className="box-border">
              {value}
            </div>
          ))}
        </div>
      </PC>
      <Mobile>
        <div className={classNames('flex flex-wrap justify-between', className)}>
          {items?.map(({ key, value }) => (
            <div key={key} className={classNames('mt-[16px] box-border', itemClassName)}>
              {value}
            </div>
          ))}
        </div>
      </Mobile>
    </>
  );
};

export default List;
